import ReactGA from 'react-ga4'
import React, { useState, useEffect } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import {
  fetchArticleBySlug,
  fetchChapterBySlug,
} from '../../services/articleAPISevicesUsingFetch'
import { Typography, Box, Skeleton, Snackbar, Alert } from '@mui/material'
import Error from '../Error'
import Article from './Article'
// import usePageTracking from '../../services/usePageTracking'
import ArticleCard from './ArticleCard'
import apiService from '../../services/ApiService'

const ArticleDetail = () => {
  // usePageTracking()
  // useEffect(() => {
  //   ReactGA.send({
  //     hitType: 'pageview',
  //     page: '/articles/:slug',
  //     title: 'Specific Article Detail Page',
  //   })
  // })

  const { slug } = useParams()
  const location = useLocation()
  // const [article, setArticle] = useState(null)
  // const [chapter, setChapter] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('') // Feedback submitted successfully 😄
  const [snackbarSeverity, setSnackbarSeverity] = useState('success') // success or error

  // Determine if we're viewing an article or chapter based on the URL
  const isArticle = location.pathname.startsWith('/articles/')
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return
    setSnackbarOpen(false)
  }

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message)
    setSnackbarSeverity(severity)
    setSnackbarOpen(true)
  }
  // useEffect(() => {
  //   const getArticle = async () => {
  //     try {
  //       // Choose the appropriate fetch function based on content type
  //       const fetchFunction = isArticle
  //         ? fetchArticleBySlug
  //         : fetchChapterBySlug
  //       const data = await fetchFunction(slug)
  //       setArticle(data)
  //       // Update page title for better SEO and user experience
  //       document.title = isArticle
  //         ? `${data.title || 'Article Detail'}`
  //         : `${data.chapterName || 'Chapter Detail'}`
  //     } catch (error) {
  //       setError(error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }

  //   getArticle()
  // }, [slug, isArticle])

  // For chapters, we need to fetch the chapter data
  // For articles, we are fetching it in Article component
  // useEffect(() => {
  //   if (!isArticle) {
  //     const getChapter = async () => {
  //       setLoading(true)
  //       try {
  //         // const data = await fetchChapterBySlug(slug)
  //         const data = await apiService.getChaptersBySlug(slug)
  //         setChapter(data)
  //         document.title = `${data.chapterName || 'GCC Tax Laws - Law Details'}`
  //       } catch (err) {
  //         console.error('Error fetching chapter:', err.message)
  //         setError(err)
  //       } finally {
  //         setLoading(false)
  //       }
  //     }

  //     getChapter()
  //   }
  // }, [slug, isArticle])

  // its chapter and data is not fetched yet
  // if (!isArticle && loading) {
  //   // return <Typography>Loading123...</Typography>
  //   return (
  //     <Box sx={{ padding: 2 }}>
  //       <Skeleton variant='text' width='80%' height={40} />
  //       <Skeleton
  //         variant='text'
  //         width='60%'
  //         height={30}
  //         sx={{ marginTop: 2 }}
  //       />
  //       <Skeleton
  //         variant='rectangular'
  //         width='100%'
  //         height={400}
  //         sx={{ marginTop: 2 }}
  //       />
  //     </Box>
  //   )
  // }

  // its chapter and data is fetched but error occurred
  // if (!isArticle && error) {
  //   return <Error error={error} />
  // }
  // For articles, just pass the slug to the Article component
  if (isArticle) {
    return (
      <>
        <Article article={{ slug }} showSnackbar={showSnackbar} />
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={1500}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{
              mt:5.5,
              width: '100%',
              // backgroundColor:
              //   snackbarSeverity === 'warning'
              //     ? '#ffcf51'
              //     : snackbarSeverity === 'error'
              //     ? '#d32f2f'
              //     : snackbarSeverity === 'success'
              //     ? '#43a047'
              //     : '#232536',
              // color: snackbarSeverity === 'warning' ? '#232536' : '#fff',
            }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </>
    )
  }

  // For chapters, display chapter info and list of articles
  // if (chapter) {
  //   return (
  //     <Box sx={{ padding: 2 }}>
  //       <Typography variant='h4' gutterBottom>
  //         {chapter.chapterName}
  //       </Typography>
  //       {chapter.articles && chapter.articles.length > 0 ? (
  //         chapter.articles.map((article) => (
  //           <ArticleCard key={article.slug} article={article} />
  //         ))
  //       ) : (
  //         <Typography>No articles found in this chapter.</Typography>
  //       )}
  //     </Box>
  //   )
  // }
  return null // show skeleton or some other loading indicator, informing the user via console and pop-up
}
export default ArticleDetail
// <Paper sx={{ margin: 2, padding: 2 }} id={`article-${article.id}`}>
//     <Box display="flex" justifyContent="space-between" alignItems="center"></Box>
